/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://i3mexevrejag3imperjztr7ili.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-yquj4mn3rfcvfcsnzs5qll3hky",
    "aws_cognito_identity_pool_id": "eu-central-1:c6fd54f2-b443-432e-a699-df6cfc450b2d",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_MoXRH7dup",
    "aws_user_pools_web_client_id": "3snl79i1v83qko4li45a5hc2qb",
    "oauth": {
        "domain": "construction42-dev.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/",
        "redirectSignOut": "http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "c42pwa134757-dev",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
